import { HarborRoleDashboard } from './HarborRoleDashboard';

const RegionalOperatorDashboard = () => {
  return <HarborRoleDashboard variant="regional" />;
};

export { RegionalOperatorDashboard };
